<script setup lang="ts">
import { ContractTypeCode } from '@models/contractType';
import CheckboxGroupFilter from '@pages/search/components/filters/CheckableTagGroup.vue';

interface ContractTypeProps {
  selected?: string[];
}

const { selected = [] } = defineProps<ContractTypeProps>();

const emit = defineEmits<{(e: 'update:selected', value: string[]): void}>();

const contractTypes = [
  ContractTypeCode.BAIL_369,
  ContractTypeCode.SERVICE,
  ContractTypeCode.RENTING,
  ContractTypeCode.PRECARIOUS_LEASE,
  ContractTypeCode.BAIL_DEROGATOIRE,
];
</script>

<template>
  <CheckboxGroupFilter
    :options="contractTypes"
    :selected="selected"
    translation-prefix="search.filters.other_filters.contract_type"
    @update:selected="emit('update:selected', $event)"
  />
</template>
